/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import defaultAxios from 'axios';
import { RRP_API_ROOT, MAMMON_API_ROOT } from 'config/hosts';
import storage from 'utils/localstorage';
import { showLoginModal } from 'components/global-header-login/login-register';
import { RequestGetDel, RequestPostPut, Generator } from './types';

export const createRequest = () =>
  defaultAxios.create({
    baseURL: RRP_API_ROOT,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': 'zh-cn',
    },
    timeout: 15 * 1000, // 15s
  });

const axios = createRequest();

axios.interceptors.request.use((request) => {
  const ssoToken = storage.get('ssoToken');

  if (ssoToken) {
    // 从localStorage里面获取token，做静默登录，暂时只用在申港
    request.headers.Authorization = `Bearer ${ssoToken}`;
  }

  return request;
});

axios.interceptors.response.use(
  // eslint-disable-next-line complexity
  (resp) => {
    const { code, data, content, message, msg } = resp.data;
    const respData = data || content || message || msg;

    if (code === 1) {
      return data;
    }

    if (code !== undefined && respData) {
      /** 0 为与平台返回， 1 为萝卜返回， 200+ 为正常返回 */
      if (code === 0 || (code >= 200 && code < 400)) {
        return respData;
      }
      if (code === -403 || message === 'Need Login') {
        showLoginModal();
      }

      return Promise.reject(resp.data);
    }

    return resp.data;
  },
  (error) => Promise.reject(error)
);

export const get: RequestGetDel = (url, config?) => axios.get(url, config);
export const post: RequestPostPut = (url, data, config) => axios.post(url, data, config);
export const put: RequestPostPut = (url, data, config) => axios.put(url, data, config);
export const del: RequestGetDel = (url, config?) => axios.delete(url, config);

export const generateRequest: Generator = (defaultConfig) => ({
  get: (url, config) => get(url, { ...defaultConfig, ...config }),
  post: (url, data, config) => post(url, data, { ...defaultConfig, ...config }),
  put: (url, data, config) => put(url, data, { ...defaultConfig, ...config }),
  del: (url, config) => del(url, { ...defaultConfig, ...config }),
});

const { get: getMammon, post: postMammon, put: putMammon, del: delMammon } = generateRequest({
  baseURL: MAMMON_API_ROOT,
});

export { getMammon, postMammon, putMammon, delMammon };

export default axios;
